export const navigationLinks = [
  { to: "/", label: "Home", end: true, footerGroup: "explore" },
  { to: "/about", label: "About", footerGroup: "explore" },
  { to: "/products", label: "Products", footerGroup: "explore" },
  { to: "/solution", label: "Solution", footerLabel: "Solutions", footerGroup: "capabilities" },
  { to: "/production", label: "Production", footerGroup: "capabilities" },
  { to: "/blog", label: "Blogs", footerGroup: "explore" },
  { to: "/contact", label: "Contact", footerGroup: "explore" },
];
